import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';
import css from '@styled-system/css';
import reactDom from 'react-dom';

const ConfirmationModal = ({ isModalOpen, setIsModalOpen, handleFunction, text }) => {
  const onCloseModal = () => {
    setIsModalOpen(false);
  };
  return reactDom.createPortal(
    isModalOpen && (
      <StyledModal>
        <Wrapper>
          <Title>{text}</Title>
          <div className="button-container">
            <Button variant="primary" style={{ width: '100%' }} mt="24px" onClick={handleFunction}>
              OK
            </Button>
            <Button style={{ width: '100%' }} mt="24px" onClick={onCloseModal}>
              cancel
            </Button>
          </div>
        </Wrapper>
      </StyledModal>
    ),
    document.getElementById('portal')
  );
};
const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99999999;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
`;
const Wrapper = styled('div')(
  css({
    width: '100%',
    maxWidth: 350,
    padding: ['1rem', '1.5rem'],
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: '.5em',
    border: '1px solid gray',
    backgroundColor: 'var(--dark-navy-blue)'
  })
);
const Title = styled.p`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  color: var(--white);
  margin: 0;
  letter-spacing: 1.2px;
`;
export default ConfirmationModal;
